import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { RecursoCampanhaFilter } from '../../filter';
import { RecursoCampanhaSearchTipo } from '../recurso-campanha-search-tipo';

@Injectable({
    providedIn: 'root'
})
export class RecursoCampanhaTipoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/recursocampanha/0/tipo`;
    }


    /** Realizada a pesquisa os recursos de campanhas agrupados pelos seus tipos */
    search(filter: RecursoCampanhaFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<RecursoCampanhaSearchTipo[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<RecursoCampanhaSearchTipo[]>(this.pathApi, {params});
    }
}
